<template>
  <footer class="footer">
    <div class="footer-logo"><img src="/Application/Home/Resource/static/images/mobile/footer-logo-magic.png" alt=""></div>
    <div class="footer-nav">
      <div class="footer-nav-item"><router-link to="/lecturer">师资</router-link></div>
      <div class="footer-nav-item"><router-link to="/course">设计室Studio</router-link></div>
      <div class="footer-nav-item"><router-link to="/achievement">案例</router-link></div>
      <div class="footer-nav-item"><router-link to="/article">专题</router-link></div>
    </div>
    <div class="code-area">
      <div class="qr-code-item">
        <img src="/Application/Home/Resource/static/images/mobile/canopyu-qrcode1.png" alt="">
        <div class="code-type">凯诺公众号</div>
      </div>
      <div class="qr-code-item">
        <img src="/Application/Home/Resource/static/images/mobile/canopyu-qrcode2.png" alt="">
        <div class="code-type">凯诺小程序</div>
      </div>
    </div>
    <div class="contact-us">
      <div class="contact-item"><span class="contact-icon"><icon icon-class="dianhua"></icon></span>010-67093037</div>
      <div class="contact-item"><span class="contact-icon"><icon icon-class="icon3"></icon></span>2917824355</div>
      <div class="contact-item"><span class="contact-icon"><icon icon-class="address" class="address-icon"></icon></span>北京市朝阳区八里庄西里97号住邦2000 4号楼17层1701号</div>
    </div>
    <div class="sns-list">
      <a href="https://space.bilibili.com/481672825?from=search&seid=6431824752793471821" class="sns-link"><icon icon-class="bilibili" class="bilibili"></icon></a>
      <a href="https://www.zhihu.com/org/kai-nuo-kong-zhong-she-ji-ke/activities" class="sns-link"><icon icon-class="zhihu"></icon></a>
      <!-- <a href="https://weibo.com/canopyu?refer_flag=1001030101_&is_hot=1" class="sns-link"><icon icon-class="unie61d"></icon></a> -->
      <!-- <a href="https://www.linkedin.com/company/17887566/" class="sns-link"><icon icon-class="in"></icon></a> -->
    </div>
    <div class="footer-reference">
      <div class="reference-links">
        <!-- <a href="" class="reference-link">用户协议</a> -->
        <a href="" class="reference-link">免责条款</a>
        <a href="" class="reference-link">隐私声明</a>
      </div>
      <div class="copyright">© {{new Date().getFullYear()}} 凯诺汇教育科技（北京）有限公司 京ICP备14022643号</div>
      <div class="partner">
        战略合作伙伴 - <a href="https://zhuomozhuomo.com" target="_blank">琢磨琢磨 ZOMOZOMO</a>
      </div>
    </div>
  </footer>
</template>

<style lang="less" scoped>
  @img-path: '/Application/Home/Resource/static/images/mobile/';
  @cano: #4DA2C7;
  .footer{
    background: url('@{img-path}footer-bg.jpg') no-repeat center center;
    background-size: cover;
    color: #FFF;
    padding-top: 40px;
    a{
      color: #FFF;
    }
    .footer-logo{
      text-align: center;
      img{
        width: 1.68rem;
      }
    }
    .footer-nav{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .footer-nav-item{
        position: relative;
        padding-right: 12px;
        &::after{
          content: '/';
          margin-left: 12px;
        }
        &:last-child{
          padding-right: 0;
          &::after{
            content: '';
            margin-left: 0;
          }
        }
        a{
          text-decoration: underline;
        }
      }
    }
    .code-area{
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .qr-code-item{
        margin: 0 10px;
        width: 90px;
        text-align: center;
        img{
          width: 100%;
        }
        .code-type{
          margin-top: 8px;
          font-size: 12px;
          line-height: 12px;
        }
      }
    }
    .contact-us{
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .contact-item{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        .contact-icon{
          width: 16px;
          height: 16px;
          margin-right: 8px;
          background: rgba(255,255,255,.2);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          .address-icon{
            font-size: 9px;
          }
          svg{
            font-size: 9px;
          }
        }
      }
    }
    .sns-list{
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 20px;
      .sns-link{
        margin-right: 40px;
        font-size: 20px;
        color: #CCC;
        .bilibili{
          font-size: 40px;
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
    .footer-reference{
      margin-top: 20px;
      padding-top: 12px;
      border-top: 1px solid #666;
      text-align: center;
      padding-bottom: 22px;
      .reference-links{
        display: flex;
        justify-content: center;
        align-items: center;
        .reference-link{
          position: relative;
          color: #999;
          padding-right: 35px;
          font-size: 12px;
          line-height: 12px;
          &:last-child{
            margin-right: 0;
            &::after{
              width: 0;
            }
          }
          &::after{
            content: '';
            position: absolute;
            right: 17px;
            top: 0;
            width: 1px;
            height: 11px;
            background: #666;
          }
        }
      }
      .copyright{
        margin-top: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
      .partner{
        margin-top: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
        a{
          color: #999;
        }
      }
    }
  }
</style>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/footer.vue